import React, { useEffect, useState } from 'react';

import Api, { exceptionNotificationAPI } from '../../services/api';
import FormCrud from '../../components/FormCrud';

const SupplierForm = () => {
    const [TenantOptions, setTenantOptions] = useState([]);

    const userData = JSON.parse(localStorage.getItem("@SoilAnalysis:user"));
    const userTenantID = userData.tenantID;

    const activeOptions = [
        { value: true, text: "Sim" },
        { value: false, text: "Não" }
    ];

    const cultures = [
        {
            label: "Descrição",
            name: "description",
            type: "input",
        },
        {
            label: "Empresa",
            name: "tenantID",
            type: "select",
            options: TenantOptions,
        },
        {
            label: "Link",
            name: "link",
            type: "input",
        },
        {
            label: "Ativo",
            name: "isActive",
            type: "select",
            options: activeOptions
        },
    ];

    const loadData = async () => {        
        Api.get('Tenant/getAllItems').then((result) => {
            if (result && result.data) {
                let options = result.data.response.map(item => ({ value: item.tenantID, text: item.name }));
                if (userTenantID ==null) {
                    options = [{ value: "", text: "Selecione" }, ...options];
                } else {
                    options = options.filter(opt => opt.value === userTenantID);
                }
        
                setTenantOptions(options);
            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        TenantOptions.length > 0 ? <FormCrud formName={"supplier"} title={"Laboratório"} fields={cultures} /> :<></>
    );
}

export default SupplierForm;
